import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";
import theme from "utils/theme";
import { Sidebar } from "components/layouts";
import { Box, Flex } from "grid-styled";
import { connect } from "react-redux";
import { Modal } from "components/styled";
import { Glossary, HowToUse, Downloads } from "../../../pages";

class Page extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isHelpOpen: false,
            isDownloadsOpen: false,
            selectedHelp: "glossary"
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        if (this.props.history.location.hash === "#downloads") {
            this.setState({ isDownloadsOpen: true });
        }
    }

    setSelectedHelp = val => {
        this.props.history.push(`#${val}`);

        this.setState({
            selectedHelp: val,
            isHelpOpen: !this.state.isHelpOpen
        });
    };

    handleHelpClose = () => {
        this.props.history.push("");
        this.setState({
            isHelpOpen: false
        });
    };


    handleDownloadsClose = () => {
        this.props.history.push("");
        this.setState({
            isDownloadsOpen: false
        });
    };

    openDownloadsModal = () => {
        this.setState(
            {
                isDownloadsOpen: true
            },
            () => {
                this.props.history.push("#downloads");
            }
        );
    };

    getHelpContent = () => {
        const { selectedHelp } = this.state;

        if (selectedHelp === "glossary") {
            return <Glossary />;
        } else {
            return <HowToUse />;
        }
    };

    render() {
        // window.scrollTo(0, 0);

        const { children, selectedLanguage, className } = this.props;

        return (
            <ThemeProvider theme={theme}>
                <div>
                    <Content lang={selectedLanguage} className="page">
                        <Sidebar setSelectedHelp={this.setSelectedHelp} openDownloadsModal={this.openDownloadsModal} />
                        <Flex className={`wrapper detail-page-container ${className}`}>
                            {React.Children.map(children, (child, i) => {
                                if (i < 2) {
                                    return <Box>{child}</Box>;
                                }
                            })}
                        </Flex>
                        <Modal
                            isOpen={this.state.isDownloadsOpen}
                            handleClose={this.handleDownloadsClose}
                        >
                            <Downloads />
                        </Modal>

                        <Modal isOpen={this.state.isHelpOpen}
                               handleClose={this.handleHelpClose}>
                            {this.getHelpContent()}
                        </Modal>
                    </Content>
                </div>
            </ThemeProvider>
        );
    }
}

const mapStateToProps = state => ({
    selectedLanguage: state.localizationReducers.selectedLanguage
});

const Content = styled.div`
  font-family: ${props =>
    props.lang === "en"
        ? '"Work Sans", sans-serif'
        : '"Noto Sans", sans-serif'};

  div,
  span,
  p,
  text,
  input,
  textarea {
    font-family: ${props =>
    props.lang === "en"
        ? "Work Sans, sans-serif"
        : "Noto Sans, sans-serif"}!important;
  }

  .tooltip {
    .title {
      font-size: ${props => (props.lang === "en" ? "14px" : "15px")};
    }
    .total-count {
      font-size: ${props => (props.lang === "en" ? "18px" : "20px")};
    }
    .view-map-detail {
      font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
      margin-top: 2px;
    }
  }

  .contact-wrap p {
    font-size: ${props => (props.lang === "en" ? "14px" : "15px")};
  }
`;

export default connect(mapStateToProps)(withRouter(Page));



// WEBPACK FOOTER //
// ./src/components/layouts/page/page.js